export default {
  campaigns: {
    data:[],
    isUploaded:false,
    isAllInCache:false,
    uploadedForWorkspace:null,
  },
  landings: {
    data:[],
    isUploaded:false,
    isAllInCache:false,
    uploadedForWorkspace:null,
    uploadedForCountryId:null
  },
  tags: {
    campaigns:{
      data:[],
      isUploaded:false,
    },
    offers:{
      data:[],
      isUploaded:false,
    },
    landings:{
      data:[],
      isUploaded:false,
    },
    flows:{
      data:[],
      isUploaded:false,
    },
    'traffic-sources':{
      data:[],
      isUploaded:false,
    },
    'affiliate-networks':{
      data:[],
      isUploaded:false,
    },
  },
  offers: {
    data:[],
    isUploaded:false,
    isAllInCache:false,
    uploadedForWorkspace:null,
    uploadedForCountryId:null
  },
  trafficSources: { 
    data:[],
    isUploaded:false,
    isAllInCache:false,
    uploadedForWorkspace:null
  },
  affiliateNetworks: { 
    data:[],
    isUploaded:false,
  },
  flows: { 
    data:[],
    isUploaded:false,
    isAllInCache:false,
    uploadedForWorkspace:null,
    uploadedForCountryId:null
  },
  trackingDomains: { 
    data:[],
    isUploaded:false,
  },
  redirectDomains: { 
    data:[],
    isUploaded:false,
  },
  integrations: { 
    data:[],
    isUploaded:false,
  },
} as {
  campaigns: {
    data:Campaign[],
    isUploaded:boolean,
    isAllInCache:boolean,
  },
  landings:{
    data:Landing[],
    isUploaded:boolean,
    isAllInCache:boolean,
    uploadedForWorkspace:string,
    uploadedForCountryId:string
  },
  tags: {
    campaigns:{
      data:Tag[],
      isUploaded:false,
    },
    offers:{
      data:Tag[],
      isUploaded:false,
    },
    landings:{
      data:Tag[],
      isUploaded:false,
    },
    flows:{
      data:Tag[],
      isUploaded:false,
    },
    'traffic-sources':{
      data:Tag[],
      isUploaded:false,
    },
    'affiliate-networks':{
      data:Tag[],
      isUploaded:false,
    },
  },
  offers:{
    data:Offer[],
    isUploaded:boolean,
    isAllInCache:boolean,
    uploadedForWorkspace:string,
    uploadedForCountryId:string
  },
  trafficSources:{
    data:TrafficSource[],
    isUploaded:boolean,
    isAllInCache:boolean,
    uploadedForWorkspace:string
  },
  flows: {
    data:[],
    isUploaded:boolean,
    isAllInCache:boolean,
    uploadedForWorkspace:string,
    uploadedForCountryId:string
  },
  trackingDomains: {
    data:TrackingDomain[],
    isUploaded:boolean,
  },
  redirectDomains: {
    data:TrackingDomain[],
    isUploaded:boolean,
  },
  integrations: {
    data:Integration[],
    isUploaded:boolean,
  },
}